import { render, staticRenderFns } from "./PendingUsersNotification.vue?vue&type=template&id=c1060d2e&"
import script from "./PendingUsersNotification.vue?vue&type=script&lang=js&"
export * from "./PendingUsersNotification.vue?vue&type=script&lang=js&"
import style0 from "./PendingUsersNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports